import React from 'react';
import { get } from 'lodash';

class ListItemThongKe extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    return (
      <span style={{ display: 'contents' }}>
        {get(this.props, 'dataList', []).map((item, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{item.model.code}</td>
            <td>{item.model.name}</td>
            {item.statistics.map((sta, idx) => (
              <td className='txt-center' key={`${i}-${idx}`}>
                {sta}
              </td>
            ))}
          </tr>
        ))}
      </span>
    );
  }
}

export default ListItemThongKe;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke/ListItemThongKe.jsx